export default "__VITE_PUBLIC_ASSET__0fca69b4__"